const KEY_PREFIX = 'tg_payment_result:'

export function claimPaymentResultDialog(orderNo, result = 'success') {
  if (!orderNo) return true
  const key = `${KEY_PREFIX}${orderNo}:${result}`
  try {
    if (sessionStorage.getItem(key)) return false
    sessionStorage.setItem(key, String(Date.now()))
  } catch {
    return true
  }
  return true
}

export function hasShownPaymentResultDialog(orderNo, result = 'success') {
  if (!orderNo) return false
  try {
    return Boolean(sessionStorage.getItem(`${KEY_PREFIX}${orderNo}:${result}`))
  } catch {
    return false
  }
}
